import { Link } from "react-router-dom";

const Switcher = ({
  type = "button",
  url,
  content,
  onClick,
  selected,
  selectedItem,
  itemsLength,
}) => {
  if (type === "link") {
    return (
      <Link
        to={url}
        className={`content ${selected && selectedItem === content ? "content-selected" : ""}`}
      >
        {content}
      </Link>
    );
  }

  return (
    <button
      value={content}
      onClick={onClick}
      className={`content ${selected && selectedItem === content ? "content-selected" : ""}`}
    >
      {itemsLength === undefined ? content : content + " (" + itemsLength + ")"}
    </button>
  );
};

export default Switcher;
